const swapVariantImage = (event, state) => {
    const variantId = event.target.dataset.variantId;
    const productId = event.target.dataset.productId;
    const image = document.querySelector(`[data-product-id="${productId}"][data-variant-id="${variantId}"].variant-image--hotswap`);
    const media = image?.closest(".media");
    const mediaImages = media?.querySelectorAll('img:not(.variant-image--hotswapped)');
    if(state==='show') {
        mediaImages?.forEach(i => i.classList.add('swatch-hidden'));
        image?.classList.add('swatch-visible');
    }else{
        setTimeout(()=>{
            mediaImages?.forEach(i => i.classList.remove('swatch-hidden'));
            image?.classList.remove('swatch-visible');
            },250);

    }
}

document.addEventListener('DOMContentLoaded', () => {
    const swatches = document.querySelectorAll('.vs-swatch');
    swatches.forEach(swatch => {
        swatch.addEventListener('mouseover', (event) => {
            swapVariantImage(event, 'show');
        });
        swatch.addEventListener('mouseout', (event) => {
            swapVariantImage(event, 'hide');
        });
    });
});

